<template>
  <div id="app" class="font-main">
    <Header />
    <Desktop v-if="!isMobile" />
    <Loading v-if="$store.state.loading" />
    <main>
      <router-view v-if="isMobile" />
    </main>
  </div>
</template>

<style lang="scss"></style>
<script>
import { isMobile } from "mobile-device-detect";
import Header from "@/components/Header.vue";
import Desktop from "@/components/Desktop.vue";
import Loading from "@/components/Loading.vue";

export default {
  name: "app",
  components: {
    Header,
    Desktop,
    Loading
  },
  data() {
    return {
      isMobile: isMobile
    };
  }
};
</script>
<style>
body {
  background-color: #000;
  color: #fff;
  font-family: Helvetica;
}

main {
  padding: 1.25rem;
}

header {
  text-align: center;
}

a {
  font-weight: bold;
  color: rgb(93, 133, 241);
}
</style>
